/* OMINA 5.0 — Page « Exercer mon droit de rétractation ».

   Trois rôles, et rien d'autre :
   1. calculer la fenêtre de rétractation à partir de la date de réception
      déclarée, puis n'ouvrir le formulaire que si la demande est recevable ;
   2. rediriger vers le bon interlocuteur quand elle ne l'est pas, sans jamais
      laisser le client sans solution ;
   3. empêcher la double soumission.

   Rappel important : un thème Shopify ne peut pas lire une commande depuis une
   page publique. Le contrôle porte donc sur la date DÉCLARÉE par le client.
   C'est un filtre, pas une preuve : le service après-vente reste décisionnaire.

   Sans JavaScript, le formulaire reste entièrement utilisable : la validation
   native du navigateur s'applique et la demande part quand même au SAV. */
(function () {
  'use strict';

  if (window.ominaRetour) return; // garde anti double initialisation
  window.ominaRetour = true;

  var JOUR_MS = 86400000;

  /* Minuit local, pour comparer des jours et non des instants. */
  function minuit(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  /* Lit une valeur d'input[type=date] (AAAA-MM-JJ) sans décalage de fuseau. */
  function lireDate(valeur) {
    if (!valeur) return null;
    var p = valeur.split('-');
    if (p.length !== 3) return null;
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    return isNaN(d.getTime()) ? null : minuit(d);
  }

  /* Article L221-19 du Code de la consommation : le jour de réception ne compte
     pas, et un délai qui expire un samedi ou un dimanche est prorogé jusqu'au
     premier jour ouvrable suivant. Les jours fériés ne sont pas traités ici :
     le SAV vérifie la date exacte, et le doute profite au client. */
  function echeance(depart, jours) {
    var d = new Date(depart.getTime() + jours * JOUR_MS);
    if (d.getDay() === 6) d = new Date(d.getTime() + 2 * JOUR_MS);
    else if (d.getDay() === 0) d = new Date(d.getTime() + JOUR_MS);
    return d;
  }

  /* En français, le premier jour du mois s'écrit « 1er » et non « 1 ».
     Intl ne le fait pas, on le corrige ici. */
  function formater(date) {
    try {
      var texte = date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
      if (date.getDate() === 1) texte = texte.replace(/^1\b/, '1er');
      return texte;
    } catch (e) {
      return date.toLocaleDateString();
    }
  }

  function afficher(zone, ton, html) {
    if (!zone) return;
    zone.className = 'omina-retour__verdict omina-retour__verdict--' + ton;
    zone.innerHTML = html;
    zone.hidden = false;
  }

  function masquer(zone) {
    if (!zone) return;
    zone.hidden = true;
    zone.innerHTML = '';
  }

  /* Ouvre ou ferme le corps du formulaire. Les champs désactivés ne sont pas
     transmis par le navigateur : une demande hors délai ne peut pas partir. */
  function basculer(corps, ouvert) {
    if (!corps) return;
    corps.hidden = !ouvert;
    var champs = corps.querySelectorAll('input, select, textarea, button');
    for (var i = 0; i < champs.length; i++) champs[i].disabled = !ouvert;
  }

  function initPortillon(portillon) {
    var champDate = portillon.querySelector('[data-omina-date-reception]');
    var zone = portillon.querySelector('[data-omina-verdict]');
    var formulaire = portillon.closest('form') || document;
    var corps = formulaire.querySelector('[data-omina-corps]');

    if (!champDate) return;

    var fenetreLegale = parseInt(portillon.dataset.ominaFenetreLegale, 10) || 14;
    var fenetreGarantie = parseInt(portillon.dataset.ominaFenetreGarantie, 10) || 30;
    var sav = portillon.dataset.ominaSav || 'sav@ominacare.fr';
    var ancreGarantie = portillon.dataset.ominaAncreGarantie || '#garantie-serenite';

    // Aucune date future n'a de sens : on borne le sélecteur natif.
    champDate.max = new Date().toISOString().slice(0, 10);

    basculer(corps, false);

    function evaluer() {
      var recue = lireDate(champDate.value);

      if (!recue) {
        masquer(zone);
        basculer(corps, false);
        return;
      }

      var aujourdhui = minuit(new Date());

      if (recue.getTime() > aujourdhui.getTime()) {
        afficher(zone, 'stop',
          '<p><strong>Cette date est dans le futur.</strong></p>' +
          '<p>Indique la date à laquelle tu as réellement reçu ton colis.</p>');
        basculer(corps, false);
        return;
      }

      var limiteLegale = echeance(recue, fenetreLegale);
      var limiteGarantie = echeance(recue, fenetreGarantie);

      if (aujourdhui.getTime() <= limiteLegale.getTime()) {
        var reste = Math.round((limiteLegale.getTime() - aujourdhui.getTime()) / JOUR_MS);
        var fin = reste === 0
          ? ", c'est-à-dire aujourd'hui."
          : ' (' + reste + (reste > 1 ? ' jours restants' : ' jour restant') + ').';
        afficher(zone, 'ok',
          '<p><strong>Ta demande est recevable.</strong> Ton délai légal de rétractation court ' +
          "jusqu'au " + formater(limiteLegale) + ' inclus' + fin +
          '</p><p>Le formulaire ci-dessous est ouvert.</p>');
        basculer(corps, true);
        return;
      }

      if (aujourdhui.getTime() <= limiteGarantie.getTime()) {
        afficher(zone, 'attention',
          '<p><strong>Ton délai légal de rétractation est écoulé</strong> depuis le ' +
          formater(limiteLegale) + '.</p>' +
          '<p>En revanche, la <strong>Garantie Sérénité OMINA — ' + fenetreGarantie +
          ' jours</strong> reste ouverte ' + "jusqu'au " + formater(limiteGarantie) +
          '. Elle couvre ta situation, et les frais de retour sont pris en charge par OMINA.</p>' +
          '<p><a href="' + ancreGarantie + '">Remplir le formulaire Garantie Sérénité</a></p>');
        basculer(corps, false);
        return;
      }

      afficher(zone, 'stop',
        '<p><strong>Les deux délais de retour sont écoulés</strong> : la rétractation légale depuis le ' +
        formater(limiteLegale) + ', la Garantie Sérénité depuis le ' + formater(limiteGarantie) + '.</p>' +
        '<p>Cela ne te prive pas de tes garanties légales : en cas de panne, de défaut ou de ' +
        'non-conformité, tu restes couvert pendant deux ans. Écris à ' +
        '<a href="mailto:' + sav + '">' + sav + '</a> avec ton numéro de commande et une ' +
        'description du problème.</p>');
      basculer(corps, false);
    }

    champDate.addEventListener('change', evaluer);
    champDate.addEventListener('input', evaluer);
    evaluer();
  }

  /* Portillon de la Garantie Sérénité : une seule fenêtre, trente jours par
     défaut. Distinct du portillon de rétractation, dont les messages parlent de
     deux délais successifs. */
  function initPortillonGarantie(portillon) {
    var champDate = portillon.querySelector('[data-omina-date-reception]');
    var zone = portillon.querySelector('[data-omina-verdict]');
    var formulaire = portillon.closest('form') || document;
    var corps = formulaire.querySelector('[data-omina-corps]');

    if (!champDate) return;

    var fenetre = parseInt(portillon.dataset.ominaFenetre, 10) || 30;
    var sav = portillon.dataset.ominaSav || 'sav@ominacare.fr';

    champDate.max = new Date().toISOString().slice(0, 10);
    basculer(corps, false);

    function evaluer() {
      var recue = lireDate(champDate.value);

      if (!recue) {
        masquer(zone);
        basculer(corps, false);
        return;
      }

      var aujourdhui = minuit(new Date());

      if (recue.getTime() > aujourdhui.getTime()) {
        afficher(zone, 'stop',
          '<p><strong>Cette date est dans le futur.</strong></p>' +
          '<p>Indique la date à laquelle tu as réellement reçu ton colis.</p>');
        basculer(corps, false);
        return;
      }

      var limite = echeance(recue, fenetre);

      if (aujourdhui.getTime() <= limite.getTime()) {
        var reste = Math.round((limite.getTime() - aujourdhui.getTime()) / JOUR_MS);
        var fin = reste === 0
          ? ", c'est-à-dire aujourd'hui."
          : ' (' + reste + (reste > 1 ? ' jours restants' : ' jour restant') + ').';
        afficher(zone, 'ok',
          '<p><strong>Ta Garantie Sérénité est ouverte</strong> ' + "jusqu'au " +
          formater(limite) + ' inclus' + fin + '</p>' +
          '<p>Le questionnaire ci-dessous est ouvert.</p>');
        basculer(corps, true);
        return;
      }

      afficher(zone, 'stop',
        '<p><strong>Ta Garantie Sérénité est écoulée</strong> depuis le ' + formater(limite) + '.</p>' +
        '<p>Cela ne te prive pas de tes garanties légales : en cas de panne, de défaut ou de ' +
        'non-conformité, tu restes couvert pendant deux ans, sans frais. Écris à ' +
        '<a href="mailto:' + sav + '">' + sav + '</a> avec ton numéro de commande et une ' +
        'description du problème.</p>');
      basculer(corps, false);
    }

    champDate.addEventListener('change', evaluer);
    champDate.addEventListener('input', evaluer);
    evaluer();
  }

  /* Un motif « produit défectueux » ne relève pas de la rétractation mais de la
     garantie légale — sans frais pour le client. On le signale, au lieu de le
     laisser s'engager dans la procédure la plus coûteuse pour lui. */
  function initMotif(select) {
    var zone = document.querySelector(select.dataset.ominaMotifCible || '');
    if (!zone) return;

    select.addEventListener('change', function () {
      zone.hidden = select.value !== select.dataset.ominaMotifSav;
    });
  }

  function initAntiDoublon(formulaire) {
    var bouton = formulaire.querySelector('[data-omina-form-submit]');
    if (!bouton) return;

    formulaire.addEventListener('submit', function () {
      if (!formulaire.checkValidity()) return;
      bouton.setAttribute('aria-busy', 'true');
      // Laisse le navigateur transmettre le formulaire avant de neutraliser le bouton.
      setTimeout(function () { bouton.disabled = true; }, 0);
    });
  }

  function init() {
    var portillons = document.querySelectorAll('[data-omina-portillon]');
    for (var i = 0; i < portillons.length; i++) initPortillon(portillons[i]);

    var garanties = document.querySelectorAll('[data-omina-portillon-garantie]');
    for (var g = 0; g < garanties.length; g++) initPortillonGarantie(garanties[g]);

    var motifs = document.querySelectorAll('[data-omina-motif-sav]');
    for (var j = 0; j < motifs.length; j++) initMotif(motifs[j]);

    var formulaires = document.querySelectorAll('.omina-form--retour');
    for (var k = 0; k < formulaires.length; k++) initAntiDoublon(formulaires[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
